import React from "react"
import Filter from "./custom-table-filter"
import { flexRender, getCoreRowModel, getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table"

//import { makeData } from ".//makeData"

function CustomTable({ columns, data }) {

  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 500
  })
  const [sorting, setSorting] = React.useState( [
    {
      id: "work_order_id", 
      desc: true,
    },
  ])
 

  const table = useReactTable({
    columns,
    data,
    debugTable: true,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onPaginationChange: setPagination,
    //no need to pass pageCount or rowCount with client-side pagination as it is calculated automatically
    state: {
      pagination
    },
    // autoResetPageIndex: false, // turn off page index reset when sorting or filtering
  })



  return (
    <>
      <table className="table table-striped table-sm table-immediate">
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => {
                return (
                  <th key={header.id} colSpan={header.colSpan}    
                  style={header.getSize() !== 150 ? {width: header.getSize()}:{}}
                  >
                    <div
                      {...{
                        className: header.column.getCanSort()
                          ? "cursor-pointer select-none"
                          : "",
                        onClick: header.column.getToggleSortingHandler()
                      }}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                      {{
                        asc: <i className='arrow-up'></i>,
                        desc: <i className='arrow-down'></i>
                      }[header.column.getIsSorted()] ?? null}
                      
                    </div>
                  </th>
                )
              })}
            </tr>
          ))}

{data.length> 5 && table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => {
                return (
                  <th key={header.id} colSpan={header.colSpan}>
                      {header.column.getCanFilter() ? (
                        <div>
                          <Filter column={header.column} table={table} />
                        </div>
                      ) : null}
                
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody>
        
          {table.getRowModel().rows.map(row => {
            return (
              <tr key={row.id} >
                {row.getVisibleCells().map(cell => {
                  return (
                    <td key={cell.id} >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {table.getPageCount() > 1 &&
      
      <div className="row" >
        <div className="col">
          <nav aria-label="Page navigation row">
            <ul className="pagination pagination-sm col">

              <li className="page-item"><a className="page-link" href="#" onClick={() => table.firstPage()} disabled={!table.getCanPreviousPage()}> {"FIRST"}</a></li>
              <li className="page-item"><a className="page-link" href="#" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}> {"<"}</a></li>
              <li className="page-item"><a className="page-link" href="#" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}> {">"}</a></li>
              <li className="page-item"><a className="page-link" href="#" onClick={() => table.lastPage()} disabled={!table.getCanNextPage()}> {"LAST"}</a></li>
             

            </ul>
          </nav>
        </div>
     
        <div className="col text-end px-3">

           
            
             <label className="px-2">Go to page # : 
              <span className="px-1">
                <input type="number" min="1" max={table.getPageCount()}
                  defaultValue={table.getState().pagination.pageIndex + 1}
                  onChange={e => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0
                    table.setPageIndex(page)
                  }} className="form-control-sm p-1 rounded w-16"
                  value={table.getState().pagination.pageIndex + 1}
                  />
              </span>
              </label>
              <label className="px-2 fw-bold">|</label> 
              <label className="px-2">Page {table.getState().pagination.pageIndex + 1} of {" "}
            {table.getPageCount().toLocaleString()}
            </label>
           
              <label className="px-2 fw-bold">|</label>
              <label> Showing {table.getRowModel().rows.length.toLocaleString()} of{" "} {table.getRowCount().toLocaleString()} Rows </label>
           
            


        </div>
     
      </div>
 }



    </>
  )

}

export default CustomTable;

